import { render, staticRenderFns } from "./CamposRequeridosMsg.vue?vue&type=template&id=1bdfbcab&scoped=true&"
import script from "./CamposRequeridosMsg.vue?vue&type=script&lang=js&"
export * from "./CamposRequeridosMsg.vue?vue&type=script&lang=js&"
import style0 from "./CamposRequeridosMsg.vue?vue&type=style&index=0&id=1bdfbcab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdfbcab",
  null
  
)

export default component.exports